import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

export default function RequireAuth({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Eğer auth bilgisi henüz yüklenmediyse bekleme göstermek mantıklı
  if (loading) return <div className="text-center mt-10 text-gray-600">Yükleniyor...</div>;

  // Giriş yapılmamışsa login sayfasına gönder (default öğrenci giriş sayfası)
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Kullanıcının rolü yetkili roller içinde değilse anasayfaya gönder
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  // Eğer kullanıcı giriş yapmış ve rol yetkiliyse alt bileşeni göster
  return children;
}
